import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import {
	AppstoreOutlined,
	ClusterOutlined,
	ColumnWidthOutlined,
	CommentOutlined,
	DatabaseOutlined,
	DownOutlined,
	ExceptionOutlined,
	ExperimentOutlined,
	FileWordOutlined,
	HomeFilled,
	LineChartOutlined,
	NumberOutlined,
	ReconciliationOutlined,
	ReloadOutlined,
	SaveOutlined,
	SearchOutlined,
	CloseOutlined,
	SlidersOutlined,
	WarningOutlined,
} from "@ant-design/icons";
import { ScatterPlotIcon, CommunityIcon } from "../../assets/icons/custom_icons";
import { usePermissions } from "src/auth/permissions/PermissionProvider";
import {
	auditMenuPermissions,
	filterMenuItemsByPermissions,
} from "src/auth/permissions/menuPermissions";

/* ==================================================================
   Menu tree.
   `key`, `link` and `children` are kept exactly as before so the
   permission filter keeps behaving identically; `to` is added for
   routing and active-state matching.
   ================================================================== */

const NAV_ITEMS = [
	{
		key: "homeLink",
		label: "خانه",
		icon: <HomeFilled />,
		to: "/",
	},
	{
		key: "modelTrainingGroup",
		label: "تحلیل دادگان",
		icon: <DatabaseOutlined />,
		children: [
			{ key: "modelTraining", to: "/ModelTraining", label: "آموزش مدل‌ها" },
			{
				key: "basedOnTimeDatasetCreating",
				to: "/BasedOnTimeDatasetCreating",
				label: "ساخت مجموعه داده زمانی",
			},
			{ key: "FileFilter", to: "/FileFilter", label: "فیلتر فایل" },
		],
	},
	{
		key: "ReviewNonMetricSpaceBtn",
		label: "نمایش هندسی واژگان",
		icon: <ScatterPlotIcon />,
		children: [
			{
				key: "ReviewNonMetricSpaceBtn0",
				to: "/ReviewNonMetricSpace?tab=0",
				label: "نمایش ابر واژگان / فضای بردار واژگان",
			},
		],
	},
	{
		key: "ReviewDataAndDefineConceptsBtn",
		label: "بررسی فاصله بین مفاهیم",
		icon: <LineChartOutlined />,
		children: [
			{
				key: "ReviewDataAndDefineConceptsBtn0",
				to: "/ReviewDataAndDefineConcepts?tab=0",
				label: "همسایگی واژگان / فاصله بین مفاهیم",
			},
			{
				key: "WordGeometryBtn3",
				label: "ساخت نقشه هندسی",
				children: [
					{ key: "WordGeometryBtn4", to: "/ReviewMetricSpace?tab=0", label: "بر اساس نشانش واژگان" },
					{ key: "WordGeometryBtn5", to: "/ReviewTopicalMetricSpace", label: "بر اساس تحلیل موضوعی" },
				],
			},
		],
	},
	{
		key: "CorrespondenceAnalysis",
		label: "استخراج دانش",
		icon: <ReconciliationOutlined />,
		children: [
			{
				key: "ProportionalityBetweenConcepts",
				to: "/ProportionalityBetweenConcepts?tab=0",
				label: "نسبت‌سنجی بین مفاهیم",
			},
			{ key: "WordSuggestions1", to: "/WordSuggestions", label: "پیشنهاد واژه" },
			{
				key: "DesignMultipleChoiceQuestions",
				to: "/DesignMultipleChoiceQuestions",
				label: "طرح سوالات چندگزینه‌ای (طیفی)",
			},
		],
	},
	// {
	// 	key: "LexicalSemantic",
	// 	link: "/LexicalSemantic",
	// 	to: "/LexicalSemantic",
	// 	label: "تحلیل معنایی واژگان",
	// 	icon: <ExperimentOutlined />
	// },
	{
		key: "LexicalSemanticAnalysis",
		label: "تحلیل معنایی واژگان",
		icon: <ExperimentOutlined />,
		children: [
			{
				key: "LexicalSemantic",
				to: "/LexicalSemantic",
				label: "استخراج وجوه معنایی",
			},
		],
	},
	{
		key: "CommunityAnalysis",
		label: "تحلیل جوامع کاربری",
		icon: <CommunityIcon />,
		children: [
			{ key: "CommunityAnalysis1", to: "/CommunityAnalysis", label: "شناسایی جوامع کاربران" },
			{
				key: "CommunityAnalysis3",
				label: "تحلیل جوامع کاربران",
				children: [
					{
						key: "TopicRecognition1",
						label: "تحلیل موضوعی",
						children: [
							{
								key: "TopicRecognition1-2",
								to: "/TopicRecognitionBarchartWithoutStopWords",
								label: "تحلیل موضوعی با حذف ایست‌واژه",
							},
						],
					},
					{
						key: "UsersRecognition",
						label: "بررسی کاربران",
						children: [
							{
								key: "InfluentialUsersRecognition",
								to: "/InfluentialUsersRecognition",
								label: "شناسایی کاربران تاثیرگذار",
							},
							{
								key: "DeepInfluentialUsersRecognition",
								to: "/DeepInfluentialUsersRecognition",
								label: "شناسایی عمیق کاربران تاثیرگذار",
							},
							{ key: "PezvakRoom", to: "/PezvakRoom", label: "شناسایی اتاق پژواک" },
						],
					},
					{
						key: "TopicalAnalysisOverTime",
						to: "/TopicalAnalysisOverTime",
						label: "تحلیل موضوعی در طول زمان",
					},
					{
						key: "TopicRecognition3",
						to: "/TopicRecognitionBubble",
						label: "تحلیل ارتباط بین موضوعات",
					},
					{
						key: "TopicRecognition4",
						to: "/TopicRecognitionDotplot",
						label: "تحلیل ارتباط بین جوامع",
					},
					{
						key: "CommunityAnalysis5",
						label: "تحلیل تناظر بین اسناد / موضوعات / زمان",
						children: [
							{
								key: "TopicRecognition5-1",
								to: "/TopicRecognitionBubbleAndSingleDotplot",
								label: "شناسایی و تحلیل خوشه‌های درون و برون موضوعی",
							},
							{
								key: "TopicRecognition5-2",
								to: "/TopicRecognitionTopicsDateDotplot",
								label: "شناسایی اخبار جعلی / داغ شدن موضوعات",
							},
							{
								key: "TopicRecognition5-3",
								to: "/TopicRecognitionTopicsUsersDotplot",
								label: "شناسایی افراد مرتبط از نظر ذهنی",
							},
						],
					},
				],
			},
		],
	},
	{
		key: "IdentifyAndReduceBias",
		label: "شناسایی و کاهش سوگیری",
		icon: <SearchOutlined />,
		children: [
			{
				key: "EstimatingBiasWithSupervision",
				to: "/EstimatingBiasWithSupervision",
				label: "تخمین سوگیری با نظارت",
			},
			{
				key: "EstimatingBiasUnsupervised",
				to: "/EstimatingBiasUnsupervised",
				label: "تخمین سوگیری بدون نظارت",
			},
		],
	},
	{
		key: "MetricSpaceComparison",
		label: "مقایسه فضاهای شناختی",
		icon: <ColumnWidthOutlined />,
		children: [
			{
				key: "TopicalMetricSpaceComparison",
				to: "/TopicalMetricSpaceComparison",
				label: "بر اساس تحلیل موضوعی ساده",
			},
			{
				key: "TopicalWeightedMetricSpaceComparison",
				to: "/TopicalWeightedMetricSpaceComparison",
				label: "بر اساس تحلیل موضوعی وزن‌دار",
			},
			{
				key: "VocabularyMetricSpaceComparison",
				to: "/VocabularyMetricSpaceComparison",
				label: "بر اساس نشانش واژگان",
			},
		],
	},
	{
		key: "Perception",
		label: "ادراک",
		icon: <ExceptionOutlined />,
		children: [
			{
				key: "CreatePerceptionRequest",
				to: "/CreatePerceptionRequest",
				label: "ساخت تحلیل ادراکی",
			},
			{
				key: "ExaminingHypothesesAndQuestionsInDocuments",
				to: "/ExaminingHypothesesAndQuestionsInDocuments",
				label: "بررسی سوال در اسناد",
			},
			{
				key: "CheckingAssumptionsInDocs",
				to: "/CheckingAssumptionsInDocs",
				label: "بررسی فرضیات در اسناد",
			},
			{
				key: "ReviewRelatedDocuments",
				to: "/ReviewRelatedDocuments",
				label: "بررسی اسناد مرتبط",
			},
			{
				key: "ManagementSummary",
				to: "/ManagementSummary",
				label: "خلاصه مدیریتی",
			},
			{
				key: "GeneralOverviewDocument",
				to: "/GeneralOverviewDocument",
				label: "دیدگاه کلی اسناد",
			},
			{ key: "Tagging", to: "/Tagging", label: "برچسب‌زنی" },
			{
				key: "ThinkThankAffects",
				to: "/ThinkThankAffects",
				label: "تاثیر اندیشکده‌ها",
			},
		],
	},
	{
		key: "Polling",
		label: "رای‌گیری",
		icon: <CommentOutlined />,
		children: [

			{ key: "UsersProfile", to: "/UsersProfile", label: "ساخت پروفایل کاربران" },
			{ key: "Survey", to: "/Survey", label: "نظرسنجی" },
			{ key: "NationalSurvey", to: "/NationalSurvey", label: "اعتبارسنجی" },
		],
	},
	{
		key: "ProductionNarrative",
		label: "تولید محتوا",
		icon: <SaveOutlined />,
		children: [
			{
				key: "ProductionNews",
				to: "/ProductionNews",
				label: "تولید خبر",
			},
			{
				key: "CredibleNarratives",
				to: "/CredibleNarratives",
				label: "تولید روایت باورپذیر",
			},
		]
	},
	{
		key: "classification",
		label: "طبقه‌بندی خودکار متن",
		icon: <SaveOutlined />,
		children: [
			{
				key: "TwoLayerSorting",
				to: "/TwoLayerSorting",
				label: "دسته‌بندی دو لایه",
			},
		],
	},
	{
		key: "wordsSuggestion",
		label: "پیشنهاد واژگان",
		icon: <FileWordOutlined />,
		to: "/WordsSuggestion",
	},
	{
		key: "userDashboard",
		label: "داشبورد کاربران",
		icon: <NumberOutlined />,
		to: "/UserDashboard",
	},
	{
		key: "EnvManagement",
		label: "مدیریت دسترسی به مدل زبانی",
		icon: <SlidersOutlined />,
		to: "/EnvManagement",
	},
];

/* ================================================================== */
/*  helpers                                                            */
/* ================================================================== */

if (process.env.NODE_ENV !== "production") {
	// Logs any menu entry whose path has no permission mapping.
	auditMenuPermissions(NAV_ITEMS);
}

const pathOf = (to) => String(to || "").split("?")[0];

/** every ancestor key of the item matching the current route */
const findActiveTrail = (items, pathname, trail = []) => {
	for (const item of items) {
		if (item.children?.length) {
			const found = findActiveTrail(item.children, pathname, [...trail, item.key]);
			if (found) return found;
		} else if (item.to && pathOf(item.to) === pathname) {
			return { trail, key: item.key };
		}
	}
	return null;
};

/** keeps branches that match the query, and every branch containing a match */
const filterTree = (items, query) => {
	if (!query) return items;
	const needle = query.trim().toLowerCase();
	const walk = (list) =>
		list
			.map((item) => {
				const selfMatch = String(item.label || "").toLowerCase().includes(needle);
				const children = item.children ? walk(item.children) : null;
				if (selfMatch) return item;
				if (children && children.length) return { ...item, children };
				return null;
			})
			.filter(Boolean);
	return walk(items);
};

const collectGroupKeys = (items, acc = []) => {
	items.forEach((item) => {
		if (item.children?.length) {
			acc.push(item.key);
			collectGroupKeys(item.children, acc);
		}
	});
	return acc;
};

/* ================================================================== */

function Sidenav({ collapsed = false, onExpand, onNavigate }) {
	const { pathname } = useLocation();
	const [openKeys, setOpenKeys] = useState([]);
	const [query, setQuery] = useState("");

	const {
		canAccess,
		loading: permissionsLoading,
		error: permissionsError,
		refreshPermissions,
	} = usePermissions();

	const navMenu = useMemo(
		() => filterMenuItemsByPermissions(NAV_ITEMS, canAccess),
		[canAccess]
	);


	const active = useMemo(() => findActiveTrail(navMenu, pathname), [navMenu, pathname]);

	// the branch holding the current page opens itself
	useEffect(() => {
		if (!active?.trail?.length) return;
		setOpenKeys((prev) => Array.from(new Set([...prev, ...active.trail])));
	}, [active]);

	const visibleMenu = useMemo(() => filterTree(navMenu, query), [navMenu, query]);

	// searching expands everything that survived the filter
	const effectiveOpenKeys = useMemo(
		() => (query ? collectGroupKeys(visibleMenu) : openKeys),
		[query, visibleMenu, openKeys]
	);

	const toggleGroup = (key) => {
		if (collapsed) {
			onExpand?.();
			setOpenKeys((prev) => (prev.includes(key) ? prev : [...prev, key]));
			return;
		}
		setOpenKeys((prev) =>
			prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
		);
	};

	const renderItems = (items, depth = 0) =>
		items.map((item) => {
			const isGroup = !!item.children?.length;
			const isOpen = effectiveOpenKeys.includes(item.key);
			const isActive = active?.key === item.key;
			const inTrail = active?.trail?.includes(item.key);

			if (isGroup) {
				return (
					<div className="nav-group" key={item.key}>
						<button
							type="button"
							className={`nav-item nav-item--group ${isOpen ? "is-open" : ""} ${inTrail ? "in-trail" : ""}`}
							style={{ paddingRight: 14 + depth * 14 }}
							onClick={() => toggleGroup(item.key)}
							title={collapsed ? item.label : undefined}
						>
							<span className="nav-icon">{item.icon || <AppstoreOutlined />}</span>
							<span className="nav-label">{item.label}</span>
							<span className="nav-chevron"><DownOutlined /></span>
						</button>

						{!collapsed && (
							<div className={`nav-sub ${isOpen ? "is-open" : ""}`}>
								<div className="nav-sub-inner">{renderItems(item.children, depth + 1)}</div>
							</div>
						)}
					</div>
				);
			}

			return (
				<Link
					key={item.key}
					to={item.to || "/"}
					className={`nav-item nav-item--leaf ${isActive ? "is-active" : ""}`}
					style={{ paddingRight: 14 + depth * 14 }}
					title={collapsed ? item.label : undefined}
					onClick={() => onNavigate?.()}
				>
					<span className="nav-icon">
						{item.icon || <span className="nav-dot" />}
					</span>
					<span className="nav-label">{item.label}</span>
				</Link>
			);
		});

	return (
		<nav className={`nav-root ${collapsed ? "is-collapsed" : ""}`}>
			<div className="nav-brand">
				<span className="nav-brand-logo">
					<img src={logo} alt="لوگو" />
				</span>
				<span className="nav-brand-copy">
					<strong>پایش فضای شناختی</strong>
					<small>برآورد فضای هندسی نگرش و باورها</small>
				</span>
			</div>

			{!collapsed && (
				<div className="nav-search">
					<SearchOutlined className="nav-search-icon" />
					<input
						className="nav-search-input"
						placeholder="جستجو در منو..."
						value={query}
						onChange={(e) => setQuery(e.target.value)}
					/>
					{query && (
						<button className="nav-search-clear" onClick={() => setQuery("")} title="پاک کردن">
							<CloseOutlined />
						</button>
					)}
				</div>
			)}

			<div className="nav-scroll">
				{permissionsError ? (
					<div className="nav-state nav-state--error">
						<WarningOutlined />
						<span>دریافت سطح دسترسی ناموفق بود</span>
						<button className="nav-retry" onClick={refreshPermissions}>
							<ReloadOutlined /> تلاش دوباره
						</button>
					</div>
				) : permissionsLoading ? (
					<div className="nav-state">
						<span className="nav-ring" />
						{!collapsed && <span>در حال دریافت دسترسی‌ها...</span>}
					</div>
				) : visibleMenu.length === 0 ? (
					<div className="nav-state">
						<ClusterOutlined />
						<span>موردی یافت نشد</span>
					</div>
				) : (
					renderItems(visibleMenu)
				)}
			</div>

			<style>{`
                .nav-root {
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    direction: rtl;
                    background: linear-gradient(180deg, #1e1b4b 0%, #312e81 55%, #2a2568 100%);
                    color: #c7d2fe;
                    font-family: inherit;
                }

                /* ---------- brand ---------- */
                .nav-brand {
                    display: flex; align-items: center; gap: 12px;
                    padding: 18px 16px 16px;
                    border-bottom: 1px solid rgba(199,210,254,.12);
                }
                .nav-brand-logo {
                    width: 42px; height: 42px; flex-shrink: 0;
                    border-radius: 13px;
                    display: grid; place-items: center;
                    background: linear-gradient(135deg, #7c3aed, #4f46e5);
                    box-shadow: 0 6px 18px rgba(79,70,229,.45);
                    overflow: hidden;
                }
                .nav-brand-logo img { width: 26px; height: 26px; object-fit: contain; }
                .nav-brand-copy { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
                .nav-brand-copy strong {
                    color: #fff; font-size: 14px; font-weight: 800;
                    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                }
                .nav-brand-copy small { color: #a5b4fc; font-size: 10.5px; font-weight: 600; }
                .is-collapsed .nav-brand { justify-content: center; padding: 18px 8px 16px; }
                .is-collapsed .nav-brand-copy { display: none; }

                /* ---------- search ---------- */
                .nav-search { position: relative; padding: 14px 14px 6px; }
                .nav-search-icon {
                    position: absolute; right: 26px; top: 24px;
                    color: #818cf8; font-size: 13px; pointer-events: none;
                }
                .nav-search-input {
                    width: 100%; box-sizing: border-box;
                    padding: 9px 34px 9px 30px;
                    background: rgba(255,255,255,.07);
                    border: 1px solid rgba(199,210,254,.16);
                    border-radius: 11px;
                    color: #eef2ff; font-size: 12.5px; font-family: inherit;
                    outline: none; transition: all .18s; direction: rtl;
                }
                .nav-search-input::placeholder { color: #818cf8; }
                .nav-search-input:focus {
                    background: rgba(255,255,255,.12);
                    border-color: #818cf8;
                    box-shadow: 0 0 0 3px rgba(129,140,248,.18);
                }
                .nav-search-clear {
                    position: absolute; left: 22px; top: 22px;
                    width: 20px; height: 20px; border-radius: 50%;
                    background: rgba(255,255,255,.12); color: #c7d2fe;
                    border: none; cursor: pointer; font-size: 9px;
                    display: grid; place-items: center;
                }
                .nav-search-clear:hover { background: #4f46e5; color: #fff; }

                /* ---------- scroll area ---------- */
                .nav-scroll {
                    flex: 1; min-height: 0;
                    overflow-y: auto; overflow-x: hidden;
                    padding: 8px 10px 18px;
                    scrollbar-width: thin;
                    scrollbar-color: rgba(199,210,254,.28) transparent;
                }
                .nav-scroll::-webkit-scrollbar { width: 6px; }
                .nav-scroll::-webkit-scrollbar-thumb {
                    background: rgba(199,210,254,.22); border-radius: 20px;
                }
                .nav-scroll::-webkit-scrollbar-thumb:hover { background: rgba(199,210,254,.4); }

                /* ---------- items ---------- */
                .nav-group { margin-bottom: 2px; }
                .nav-item {
                    position: relative;
                    width: 100%; box-sizing: border-box;
                    display: flex; align-items: center; gap: 11px;
                    padding: 10px 14px;
                    margin-bottom: 2px;
                    background: transparent; border: none;
                    border-radius: 12px;
                    color: #c7d2fe;
                    font-family: inherit; font-size: 13px; font-weight: 700;
                    text-align: right; text-decoration: none;
                    cursor: pointer; transition: all .18s;
                }
                .nav-item:hover { background: rgba(255,255,255,.08); color: #fff; }
                .nav-item.in-trail { color: #e0e7ff; }
                .nav-item--group.is-open { background: rgba(255,255,255,.06); color: #fff; }

                .nav-item--leaf.is-active {
                    background: linear-gradient(90deg, rgba(124,58,237,.95), rgba(79,70,229,.85));
                    color: #fff;
                    box-shadow: 0 6px 18px rgba(79,70,229,.35);
                }
                .nav-item--leaf.is-active::before {
                    content: "";
                    position: absolute; right: -10px; top: 50%;
                    transform: translateY(-50%);
                    width: 4px; height: 22px; border-radius: 4px;
                    background: #a5b4fc;
                }

                .nav-icon {
                    width: 22px; flex-shrink: 0;
                    display: inline-flex; align-items: center; justify-content: center;
                    font-size: 15px; color: #a5b4fc; transition: color .18s;
                }
                .nav-item:hover .nav-icon,
                .nav-item--group.is-open .nav-icon { color: #c4b5fd; }
                .nav-item--leaf.is-active .nav-icon { color: #fff; }
                .nav-dot {
                    width: 5px; height: 5px; border-radius: 50%;
                    background: currentColor; opacity: .55;
                }

                .nav-label {
                    flex: 1; min-width: 0;
                    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
                    line-height: 1.7;
                }
                .nav-chevron {
                    flex-shrink: 0; font-size: 10px; color: #818cf8;
                    transition: transform .22s ease;
                }
                .nav-item--group.is-open .nav-chevron { transform: rotate(180deg); color: #c4b5fd; }

                /* ---------- nested ---------- */
                .nav-sub {
                    display: grid; grid-template-rows: 0fr;
                    transition: grid-template-rows .24s ease;
                }
                .nav-sub.is-open { grid-template-rows: 1fr; }
                .nav-sub-inner { overflow: hidden; }
                .nav-sub .nav-item { font-size: 12.5px; font-weight: 600; }
                .nav-sub .nav-item--leaf .nav-label { white-space: normal; line-height: 1.85; }

                /* ---------- collapsed ---------- */
                .is-collapsed .nav-label,
                .is-collapsed .nav-chevron { display: none; }
                .is-collapsed .nav-item { justify-content: center; padding: 12px 0 !important; }
                .is-collapsed .nav-icon { font-size: 17px; }
                .is-collapsed .nav-item--leaf.is-active::before { display: none; }

                /* ---------- states ---------- */
                .nav-state {
                    display: flex; flex-direction: column; align-items: center; gap: 10px;
                    padding: 36px 16px; text-align: center;
                    color: #a5b4fc; font-size: 12.5px; font-weight: 700;
                }
                .nav-state--error { color: #fca5a5; }
                .nav-ring {
                    width: 24px; height: 24px;
                    border: 3px solid rgba(199,210,254,.25); border-top-color: #a5b4fc;
                    border-radius: 50%; animation: nav-spin .8s linear infinite;
                }
                @keyframes nav-spin { to { transform: rotate(360deg); } }
                .nav-retry {
                    display: inline-flex; align-items: center; gap: 6px;
                    background: rgba(255,255,255,.1); color: #fff;
                    border: 1px solid rgba(255,255,255,.18); border-radius: 20px;
                    padding: 5px 13px; font-size: 11.5px; font-weight: 800;
                    cursor: pointer; font-family: inherit; transition: all .18s;
                }
                .nav-retry:hover { background: #4f46e5; border-color: #4f46e5; }
            `}</style>
		</nav>
	);
}

export default Sidenav;
